import request from '@/utils/request'

//获取轮播图
export function GetHeaderImg() {
    return request({
        url: 'dev-api/home/get_img',
    })
}

//获取动态上新
export function GetCaseImg(offset) {
    return request({
        url: `dev-api/home/swiperList?offset=${offset}`,

    })
}

//获取商品详情
export function GetOrderImg(order_id) {
    return request({
        url: `dev-api/home/detailes_info?artical_id=${order_id}`,

    })
}

//获取商品列表的api
export function GetOrderApi(limit, offset) {
    return request({
        url: `dev-api/pc/get_order?offset=${offset}&limit=${limit}`,

    })
}

//获取进度
export function SpeedApi(offset,limit, search,designer,foreman) {
    return request({
        url: `dev-api/pc/speed_all?limit=${limit}&offset=${offset}&search=${search}&designer=${designer}&foreman=${foreman}`,

    })
}

// designtaskapi
//获取设计工种
export function DesignTask() {
    return request({
        url: `dev-api/plan/designtaskapi`,

    })
}



//获取进度
export function TodayCustomer() {
    return request({
        url: `dev-api/pc/todaycustomer`,

    })
}

//获取进度
export function TodaySpeed() {
    return request({
        url: `dev-api/pc/todayspeed`,

    })
}


//获取选材料
export function GetMaterial(limit,offset,search,designer) {
    return request({
        url: `dev-api/pc/SiteAPIView?limit=${limit}&offset=${offset}&search=${search}&designer=${designer}`,

    })
}

//获取所有的material
export function GetAllMaterial(product_id) {
    return request({
        url: `dev-api/pc/getallmaterial?product_id=${product_id}`,

    })
}

//选材料修改或者添加
export function MaterialSelectionAPI(data,contract_id) {
    return request({
        url: `dev-api/pc/materialapi/${contract_id}/`,
        method: 'POST',
        data: data

    })

}

//获取选材料
export function GetMaterialInfo(contract_id) {
    return request({
        url: `dev-api/pc/materialapi/${contract_id}/`,

    })
}


//获取预算房子
export function GetBudget(limit,offset,search) {
    return request({
        url: `dev-api/pc/budgetApi?limit=${limit}&offset=${offset}&search=${search}`,

    })
}

//添加面积
export function AddArea(area) {
    return request({
        url: `dev-api/pc/addarea`,
        method : 'POST',
        data:area

    })
}

//添加预算价
export function AddBudget(area) {
    return request({
        url: `dev-api/pc/budgetprice`,
        method : 'POST',
        data:area

    })
}

//添加预算
export function BudgetDetails(data) {
    return request({
        url: `dev-api/pc/addbudgetdetails`,
        method : 'POST',
        data:data

    })
}

//获取添加预算时用的数据
export function GetBudgetInfo(id,product_id,ara_id) {
    return request({
        url: `dev-api/pc/budgetinfo?id=${id}&product_id=${product_id}&ara_id=${ara_id}`,

    })
}

export function GetAraInfo() {
    return request({
        url: `dev-api/pc/getaralist`,

    })
}

//获取筛选数据
export function GetFilterInfo(customer,product_id) {
    return request({
        url: `dev-api/pc/addbudgetdetails?customer=${customer}&product=${product_id}`,

    })
}


//获取进度
export function DesignSpeedApi(offset,limit, search,designer) {
    return request({
        url: `dev-api/pc/getdesignapi?limit=${limit}&offset=${offset}&search=${search}&designer=${designer}`,

    })
}

//获取添加预算时用的数据
export function GetDesigner() {
    return request({
        url: `dev-api/home/get_designer`,

    })
}

//获取添加预算时用的数据
export function GetForemanDesigner() {
    return request({
        url: `dev-api/construction/userinfoselect`,

    })
}

//获取添加预算时用的数据
export function GetProductList(customer_id,type_item) {
    return request({
        url: `dev-api/pc/getproduct?customer_id=${customer_id}&type_item=${type_item}`,

    })
}

//添加预算价
export function getDetailsInfo(data) {
    return request({
        url: `dev-api/pc/getdetalsinfo`,
        method : 'POST',
        data:data

    })
}
//锁定Api
export function savebudget(data) {
    return request({
        url: `dev-api/pc/savebudgetapi`,
        method : 'POST',
        data:data

    })
}

// 导出一个函数，用于保存预算
export function getSaveBudget(customer_id) {
    // 发送一个POST请求，请求的URL为dev-api/pc/savebudgetapi，请求的数据为data
    return request({
        url: `dev-api/pc/getsavebudgetapi/${customer_id}/`,
    })
}

export function getWorkTreeApi() {
    // 发送一个POST请求，请求的URL为dev-api/pc/savebudgetapi，请求的数据为data
    return request({
        url: `dev-api/pc/getworktreeapi`,
    })
}

export function saveBudgetDetails(customer_id,data) {
    // 发送一个POST请求，请求的URL为dev-api/pc/savebudgetapi，请求的数据为data
    return request({
        url: `dev-api/pc/getsavebudgetapi/${customer_id}/`,
        method : 'POST',
        data:data
    })
}

export function AddBudgetApi(customer_id,data) {
    // 发送一个POST请求，请求的URL为dev-api/pc/savebudgetapi，请求的数据为data
    return request({
        url: `dev-api/pc/adddeletebudgetapi/${customer_id}/`,
        method : 'POST',
        data:data
    })
}

export function GetAddBudgetApi(customer_id) {
    // 发送一个POST请求，请求的URL为dev-api/pc/savebudgetapi，请求的数据为data
    return request({
        url: `dev-api/pc/adddeletebudgetapi/${customer_id}/`,
    })
}

export function GetRemarksApi() {
    // 发送一个POST请求，请求的URL为dev-api/pc/savebudgetapi，请求的数据为data
    return request({
        url: `dev-api/pc/getremarksapi`,
    })
}

//获取预算房子
export function GetCost(limit,offset,search) {
    return request({
        url: `dev-api/pc/costapi?limit=${limit}&offset=${offset}&search=${search}`,

    })
}

export function getBudgetCost(customer_id) {
    // 发送一个POST请求，请求的URL为dev-api/pc/savebudgetapi，请求的数据为data
    return request({
        url: `dev-api/pc/getBudgetCost/${customer_id}/`,
    })
}

export function getContractList(limit,offset,search) {
    return request({
        url: `dev-api/home/labor_contract?limit=${limit}&offset=${offset}&search=${search}`,
    })
}

export function getLaborWork(contract_id) {
    return request({
        url: `dev-api/pc/laborlist/${contract_id}/`,
    })
    
}

export function submitLaborWork(contract_id,data) {
    return request({
        url: `dev-api/pc/laborlist/${contract_id}/`,
        method : 'POST',
        data:data
    })
    
}



export function getForeman() {
    return request({
        url: `dev-api/construction/userinfoselect`,
    })
    
}